import React from "react";

import { SimpleEmployerBreadcrumbs } from "EmployerDashboard/Components/Breadcrumbs";
import arrayMutators from "final-form-arrays";
import { Form } from "react-final-form";
import { Link, RouteComponentProps, useHistory } from "react-router-dom";
import { validateRequired } from "Utils/Validations";

import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import { useUpdateBenAdminOpenEnrollmentSetupMutation } from "../redux";
import { CardSection } from "Cobalt/Card";
import { TitleSmall } from "Cobalt/Header";
import DashboardHeader from "Common/DashboardHeader";
import { SIFinalFormField, SIFinalFormMultiFileInput } from "Common/forms";
import { Col, Row } from "Common/Grid";
import { Li, Ul } from "Common/HTML";
import Icon from "Common/Icon";
import BodyText from "Theme/BodyText";
import Button, { LinkButton } from "Theme/Button";

const formFieldInfo = {
  medical: {
    sectionTitle: "Medical Benefits",
    inputName: "medicalDocuments",
    ratesInputName: "medicalRates",
  },
  dental: {
    sectionTitle: "Dental Benefits",
    inputName: "dentalDocuments",
    ratesInputName: "dentalRates",
  },
  vision: {
    sectionTitle: "Vision Benefits",
    inputName: "visionDocuments",
    ratesInputName: "visionRates",
  },
  life: {
    sectionTitle: "Life Benefits",
    inputName: "lifeDocuments",
    ratesInputName: "lifeRates",
  },
  shortTermDisability: {
    sectionTitle: "Short Term Disability Benefits",
    inputName: "shortTermDisabilityDocuments",
    ratesInputName: "shortTermDisabilityRates",
  },
  longTermDisability: {
    sectionTitle: "Long Term Disability Benefits",
    inputName: "longTermDisabilityDocuments",
    ratesInputName: "longTermDisabilityRates",
  },
};

const OpenEnrollmentPlansPage: React.FC<RouteComponentProps<{}>> = () => {
  const history = useHistory();
  const [updateBenAdminOpenEnrollmentSetup] = useUpdateBenAdminOpenEnrollmentSetupMutation();
  const submitHandler = async (values) => {
    const res = await updateBenAdminOpenEnrollmentSetup(values);
    if (res.error) {
      const { errors } = res.error.data;
      return errors;
    }
    history.push("/benefits-administration/open-enrollment-setup/processing-plans");
    return null;
  };
  return (
    <Chrome title="SimplyInsured - Broker Dashboard">
      <Layout>
        <Form
          onSubmit={submitHandler}
          initialValues={{}}
          mutators={{
            ...arrayMutators,
          }}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <SimpleEmployerBreadcrumbs title="Open Enrollment Setup" px={0} />
              <DashboardHeader
                title="Open Enrollment Setup"
                subtitle="Please upload plan and pricing documents for each benefit type the company is offering."
                px={0}
              >
                <BodyText mt={4}>
                  Example Documents:
                  <Ul pl={4} mb={0}>
                    <Li>Summary of Benefits and Coverage</Li>
                    <Li>Renewal Packets</Li>
                  </Ul>
                </BodyText>
              </DashboardHeader>
              {["medical", "dental", "vision", "life", "shortTermDisability", "longTermDisability"].map((benefit) => (
                <CardSection px={0} pb={2} key={benefit}>
                  <Row>
                    <Col>
                      <TitleSmall mt={0} mb={3}>
                        {formFieldInfo[benefit].sectionTitle}
                      </TitleSmall>
                    </Col>
                  </Row>
                  <Row>
                    <SIFinalFormField
                      sm={6}
                      md={4}
                      name={formFieldInfo[benefit].inputName}
                      label="Plan Documents"
                      component={SIFinalFormMultiFileInput}
                      validate={benefit === "medical" ? validateRequired : undefined}
                    />
                    <SIFinalFormField sm={6} md={4} name={formFieldInfo[benefit].ratesInputName} label="Plan Rates" component={SIFinalFormMultiFileInput} />
                  </Row>
                </CardSection>
              ))}
              <CardSection className="flex justify-between" px={0}>
                <LinkButton component={Link} size="medium" to="/employer-dashboard" color="link" pl={0}>
                  <Icon icon="chevron-left" pr={3} />
                  Back
                </LinkButton>
                <Button type="submit" size="medium">
                  Next
                </Button>
              </CardSection>
            </form>
          )}
        </Form>
      </Layout>
    </Chrome>
  );
};

export default OpenEnrollmentPlansPage;
